import { Typography } from '@mui/material';

import { AuthFormHeaderProps } from './interface';
import './styles.scss';

export const AuthFormHeader = ({
  title,
  subTitle,
}: AuthFormHeaderProps): JSX.Element => (
  <>
    <Typography
      variant='h4'
      color='secondary'
      fontWeight='bold'
      className='auth-form-header-title'
    >
      {title}
    </Typography>
    <Typography variant='body1' color='secondary'>
      {subTitle}
    </Typography>
  </>
);
